import React, { Component } from 'react';
import '../../styles/index.scss';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import UserList from '../Users/UsersList';
import UserDashboard from '../Users/Dashboard';
import { Link, withRouter } from 'react-router-dom';
import MainDashboard from './Dashboard';
const { Header, Content, Footer, Sider } = Layout;

class App extends Component {
  constructor(props) {
    super(props);
    console.log('in initialize');
  }

  render() {
    return (
      <Layout>
        <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
          <Link to={'/'}>
            <h1 className="logo">Stackd</h1>
          </Link>
        </Header>
        <Content style={{ padding: '0 50px', marginTop: 64 }}>
          <Sider
            style={{
              overflow: 'auto',
              height: 'calc(100vh - 50px)',
              position: 'fixed',
              left: 0
            }}
          >
            <div className="logo" />
            <UserList />
          </Sider>
          <Layout style={{ marginLeft: 200 }}>
            <Content style={{ margin: '32px 0 0', overflow: 'initial' }}>
              <Switch>
                <Route path="/" exact={true} component={MainDashboard} />
                <Route path="/:identifier" component={UserDashboard} />
              </Switch>
            </Content>
            <Footer style={{ textAlign: 'center' }}>
              Ant Design ©2018 Created by Ant UED
            </Footer>
          </Layout>
        </Content>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/modules/App/index.js